<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useError } from '#app/composables/error';
import { hasErrorCode } from '#layers/base/public';
import { settingsOverlayPath } from '#layers/global-settings/public';
import { ErrorScreen } from '#layers/ui/public';
import { useWorkspaceStore } from '#layers/workspace/public';

const error = useError();

const { currentWorkspaceSlug } = storeToRefs(useWorkspaceStore());

const isWorkspaceAccessDenied = computed(() => error.value && hasErrorCode(error.value, 'WORKSPACE_ACCESS_DENIED'));
</script>

<template>
	<div v-if="error" class="h-screen">
		<ErrorScreen :error>
			<DButton v-if="isWorkspaceAccessDenied" size="sm" :to="settingsOverlayPath('organization/workspaces')" :label="$t('workspace.back_to_workspaces')" />
			<DButton v-else-if="!currentWorkspaceSlug" size="sm" to="/" :label="$t('workspace.return_to_dashboard')" />
			<DButton v-else size="sm" :to="{ name: 'workspace-home', params: { workspace: currentWorkspaceSlug } }" :label="$t('workspace.return_to_workspace')" />
		</ErrorScreen>
	</div>
</template>
